export default __webpack_public_path__ + "static/media/h5_guide_bg_top.7a1553aa.png";